<template>
  <div class="mt-4 border-b lg:mt-6" :class="[deviderColorClass[deviderColor ?? 'primary']]">
    <button
      :id="`collapse-button-${id}`"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-controls="`collapse-content-${id}`"
      class="mb-4 flex w-full items-center justify-between text-left text-sm font-bold focus:outline-none focus:ring-2 focus:ring-offset-2 lg:mb-6 lg:text-md"
      :class="[
        darkMode ? 'text-text-light focus:ring-white' : 'text-text-dark focus:ring-brand-02',
      ]"
      @click="toggleCollapse"
      @keydown.space.prevent="toggleCollapse"
      @keydown.enter.prevent="toggleCollapse"
    >
      <span>{{ title }}</span>
      <BaseIcon class="shrink-0" :icon="isOpen ? 'Minus' : 'Plus'" aria-hidden="true" />
    </button>

    <transition
      enter-active-class="transition-max-h duration-500 ease-in-out"
      enter-from-class="max-h-0 opacity-0"
      enter-to-class="max-h-screen opacity-100"
      leave-active-class="transition-max-h duration-500 ease-in-out"
      leave-from-class="max-h-screen opacity-100"
      leave-to-class="max-h-0 opacity-0"
    >
      <div
        v-show="isOpen"
        :id="`collapse-content-${id}`"
        role="region"
        :aria-labelledby="`collapse-button-${id}`"
        class="mb-6 mt-4 text-xs lg:text-sm"
        :class="[darkMode ? 'text-text-light' : 'text-text-dark']"
      >
        <div class="rte-default" v-html="text"></div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { IBaseCollapse } from './BaseCollapse'
import BaseIcon from '../BaseIcon/BaseIcon.vue'

const isOpen = ref(false)

withDefaults(defineProps<IBaseCollapse>(), {
  id: '1',
  deviderColor: 'primary',
  darkMode: false,
})

const toggleCollapse = () => {
  isOpen.value = !isOpen.value
}

const deviderColorClass = {
  primary: 'border-border-light',
  secondary: 'border-border-dark',
}
</script>